import treatmentAPI from '@/app/apis/main/treatment/treatment-api.js';

export default {
	/**
	 * @return {object} treatment list
	 */
	async getTreatmentList(queryParams) {
		return treatmentAPI.getTreatmentList(queryParams);
    },
	/**
	 * @return {object} frequencies
	 */
	async getProductTreatmentFrequency() {
		return treatmentAPI.getProductTreatmentFrequency();
    }
}